module.exports = __webpack_public_path__ + "img/about-corporate-play.09b86af7.png";